import type { AccountView } from './types';
import { client } from './client';
import { apiPaths } from './paths';

let recoveryPromise: Promise<AccountView | null> | null = null;
export const SESSION_RESUMED_EVENT = 'fp:session-resumed';
export const RECOVERY_TIMEOUT_MS = 1800;

export function withRecoveryTimeout<T>(promise: Promise<T>, timeoutMs = RECOVERY_TIMEOUT_MS): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<T>((_, reject) => {
    timer = setTimeout(() => reject(new Error('recovery request timeout')), timeoutMs);
  });
  return Promise.race([promise, timeout]).finally(() => {
    if (timer) clearTimeout(timer);
  });
}

export function emitSessionResumed(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(SESSION_RESUMED_EVENT));
}

/**
 * 页面恢复时验证并恢复会话。
 *
 * 通过同一个受保护的 /me 请求触发现有 401 → refresh → replay 链路，
 * 并用 single-flight 合并 visibilitychange / pageshow / online 产生的并发恢复。
 * 网络失败只返回 null，不能被解释成登出。
 */
export function recoverSession(): Promise<AccountView | null> {
  if (recoveryPromise) return recoveryPromise;
  if (!client.getAccess() && !client.getRefresh()) return Promise.resolve(null);

  recoveryPromise = withRecoveryTimeout(client.get<AccountView>(apiPaths.me.base))
    .catch(() => null)
    .finally(() => {
      recoveryPromise = null;
    });
  return recoveryPromise;
}
